import { fetchAccommodation } from './fetchAccommodation'

export const FETCH_CONFIG_BEGIN = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CONFIG_BEGIN })
    let config = JSON.parse(
      localStorage.getItem('ylg_accommodation_details_config')
    )
    if (config) {
      config = {
        ...config,
        brand: config?.brand,
        accommodationId: config?.accommodationId,
      }

      dispatch({ type: FETCH_CONFIG_SUCCESS, payload: config })
      dispatch(fetchAccommodation())
    } else {
      dispatch({
        type: FETCH_CONFIG_ERROR,
        payload:
          'There was an error retrieving configuration - please wait a moment, then try again.',
      })
    }
  } catch (err) {
    dispatch({ type: FETCH_CONFIG_ERROR, payload: err })
  }
}
